import React from 'react';

import {Modal, Dialogue, Text, Button, Icon} from '@albert-io/atomic';

interface Props {
  handleClose?: () => void;
}

const RetailAssessmentModal = ({handleClose}: Props) => {
  return (
    <Modal ariaLabel='Taking an assessment tips' handleClose={handleClose}>
      {({CloseButtonWrapper, modalContentStyle}) => {
        return (
          <Dialogue
            inModal
            hideCloseBtn
            alignTitle='center'
            className={modalContentStyle}
            title='Before you begin...'
          >
            <Dialogue.Body>
              <div className='py-x2 flex'>
                <div className='mr-x4'>
                  <Icon className='content-tertiary-inverse text-[32px]' icon={['far', 'clock']} />
                </div>
                <Text>Time yourself using a stopwatch or clock.</Text>
              </div>
              <div className='py-x2 flex'>
                <div className='mr-x4'>
                  <Icon
                    className='content-tertiary-inverse text-[32px]'
                    icon={['far', 'sticky-note']}
                  />
                </div>
                <Text>
                  After you complete the exam, note your accuracy so you can compare with other
                  attempts.
                </Text>
              </div>
              <div className='py-x2 flex'>
                <div className='mr-x4'>
                  <Icon className='content-tertiary-inverse text-[32px]' icon={['far', 'redo']} />
                </div>
                <Text>
                  You can restart the exam at any time by returning to the assessment page.{' '}
                  <Text color='tertiary'>
                    We recommend finishing the entire exam before restarting.
                  </Text>
                </Text>
              </div>
            </Dialogue.Body>
            <Dialogue.BtnGroup align='right'>
              <CloseButtonWrapper>
                <Button>Start</Button>
              </CloseButtonWrapper>
            </Dialogue.BtnGroup>
          </Dialogue>
        );
      }}
    </Modal>
  );
};

export default RetailAssessmentModal;
